import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastyService } from 'ng2-toasty';
import { ExperiencesService } from '../../experiences/experiences.service';
import { Interaction } from '../interaction.model';
import { InteractionsService } from '../interactions.service';

@Component({
  selector: 'app-add-interaction',
  templateUrl: './add-interaction.component.html',
  styleUrls: ['./add-interaction.component.scss']
})
export class AddInteractionComponent implements OnInit {

  interactionType: {label?: string, value?: string, image?: string, description?: string} = {};
  availableInteractionTypes = [
    {
      label: 'Quiz',
      value: 'quiz',
      image: 'quiz.png',
      description: 'Una semplice descrizione che aiuti l\'utente a capire a cosa fa riferimento questo interaction type.'
    },
    {
      label: 'Left or Right',
      value: 'leftRight',
      image: 'left-right.png',
      description: 'Una semplice descrizione che aiuti l\'utente a capire a cosa fa riferimento questo interaction type.'
    },
    {
      label: 'Memory',
      value: 'memory',
      image: 'memory.png',
      description: 'Una semplice descrizione che aiuti l\'utente a capire a cosa fa riferimento questo interaction type.'
    },
    {
      label: 'Quadrato Magico',
      value: 'quadratoMagico',
      image: 'quadrato-magico.png',
      description: 'Una semplice descrizione che aiuti l\'utente a capire a cosa fa riferimento questo interaction type.'
    },
    /* {
      label: 'Mappa Immagine',
      value: 'mappa-immagine',
      image: 'mappa-immagine.png',
      description: 'Una semplice descrizione che aiuti l\'utente a capire a cosa fa riferimento questo interaction type.'
    }, */
    /* {
      label: 'Scratch',
      value: 'scratch',
      image: 'scratch.png',
      description: 'Una semplice descrizione che aiuti l\'utente a capire a cosa fa riferimento questo interaction type.'
    }, */
    {
      label: 'Indovina la parola',
      value: 'indovinaParola',
      image: 'indovina-parola.png',
      description: 'Una semplice descrizione che aiuti l\'utente a capire a cosa fa riferimento questo interaction type.'
    },
    {
      label: 'Statica',
      value: 'statica',
      image: 'statica.png',
      description: 'Una semplice descrizione che aiuti l\'utente a capire a cosa fa riferimento questo interaction type.'
    },
    {
      label: 'Video',
      value: 'video',
      image: 'video.png',
      description: 'Una semplice descrizione che aiuti l\'utente a capire a cosa fa riferimento questo interaction type.'
    },
    {
      label: 'Audio',
      value: 'audio',
      image: 'audio.png',
      description: 'Una semplice descrizione che aiuti l\'utente a capire a cosa fa riferimento questo interaction type.'
    },
    /* {
      label: 'Custom',
      value: 'custom',
      image: 'custom.png',
      description: 'Una semplice descrizione che aiuti l\'utente a capire a cosa fa riferimento questo interaction type.'
    } */
  ];
  startConfigInteraction = false;
  expPath: any[];
  intOrder: number;
  tempExpId: number;
  


  constructor(
    private intService: InteractionsService,
    private toastyService: ToastyService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private expService: ExperiencesService
  ) { }

  ngOnInit(): void {
    /* this.interactionType.value = 'quiz';
    this.startConfigInteraction = true; */
    if (this.activatedRoute.snapshot.queryParams.expPath) {
      this.expPath = this.activatedRoute.snapshot.queryParams.expPath.split('/');
      this.intOrder = + this.activatedRoute.snapshot.queryParams.order;
      this.tempExpId = + this.activatedRoute.snapshot.queryParams.tempExpId;
    }
  }

  addInteraction(interaction: Interaction): void {
    this.intService.addInteraction(interaction)
    .subscribe((res: {data: any}) => {
        this.toastyService.success({
          title: 'Interaction salvata',
          msg: 'La tua Interaction "<b>' + res.data.title + '</b>" è stata salvata e aggiunta correttamente.'
        });
        if (this.expPath) {
          console.log('res', res);
          const intId = + res.data.id;
          let groupId = null;
          if (this.expPath[this.expPath.length -2] !== 'experiences') {
            groupId = + this.expPath[this.expPath.length -1];
          }
          // TODO: CHIAMATA PER ASSOCIARE L'INT ALLA EXP
          this.expService.addIntOrGroupToExp(this.tempExpId, intId, groupId, this.intOrder)
          .subscribe((res: {data: any}) => {
            this.router.navigate(this.expPath);
          },
          (err) => {
            console.log('Errore ', err.error.message);
          });
          this.router.navigate(this.expPath);
        } else {
          this.router.navigate(['/interactions']);
        }
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });
  }

}
